import { LitElement, css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';

import { AtlAppCardPlaceholderProps } from './placeholders.props';

import * as PlaceholderTags from './placeholders.tagnames';
import { SpanPlaceholderSizes } from './placeholders.enums';

@customElement(PlaceholderTags.AppCard)
export class AtlAppCardPlaceholder extends LitElement implements AtlAppCardPlaceholderProps {
    declare hideIcon?: boolean | undefined;

    static properties = {
        hideIcon: { attribute: 'hide-icon', type: Boolean },
        glow: { type: Boolean }    
    }

    static styles = [
        ...getGlobalStyleSheets(),
        css`.app-icon > atlantis-span-placeholder {
                height: 100%;
                display: flex;
                align-items: center;
        }`
    ];
    
    render() {
        return html`
            <div class="card app-card fixed-size">
                <div class="app-card-header">
                    <div class="card-title">
                        <atlantis-span-placeholder size=${SpanPlaceholderSizes.Large} glow></atlantis-span-placeholder>
                    </div>
                    ${this.hideIcon ? nothing : html`
                        <div class="app-icon">
                            <atlantis-span-placeholder size=${SpanPlaceholderSizes.ExtraSmall} glow></atlantis-span-placeholder>
                        </div>
                    `}
                </div>
                <div class="card-body">
                    <div class="card-text">
                        <atlantis-span-placeholder size=${SpanPlaceholderSizes.Medium} glow></atlantis-span-placeholder>
                        <atlantis-span-placeholder size=${SpanPlaceholderSizes.Smaller} glow></atlantis-span-placeholder>
                        <atlantis-span-placeholder size=${SpanPlaceholderSizes.Large} glow></atlantis-span-placeholder>
                        <atlantis-span-placeholder size=${SpanPlaceholderSizes.Small} glow></atlantis-span-placeholder>
                    </div>
                </div>
            </div>
        `;
    }
}